import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { WorkpaperRoleEnum } from '../types/workpaper';

type GetUserWorkpaperRoleResponse = {
    role: WorkpaperRoleEnum;
};

async function getUserWorkpaperRole({
    userId,
    workpaperId,
}: {
    userId: string;
    workpaperId?: string;
}): Promise<GetUserWorkpaperRoleResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/user-workpaper-role?userId=${userId}`);
    return data;
}

export function useUserWorkpaperRole({
    userId,
    workpaperId,
}: {
    userId: string;
    workpaperId?: string;
}): UseQueryResult<GetUserWorkpaperRoleResponse, AxiosError> {
    return useQuery(['user-workpaper-role', userId, workpaperId], () => getUserWorkpaperRole({ userId, workpaperId }), {
        keepPreviousData: true,
        enabled: Boolean(workpaperId),
    });
}
